export const titleMap = {
    'my-campaigns': 'Campaigns list',
    'active-campaigns': 'Active campaigns',
    'browse-campaigns': 'Browse campaigns',
    'best-campaigns': 'Best campaigns'
}

export const defaultErrorMessage = 'An error occurred. Please contact administrator!';